module.exports = __webpack_public_path__ + "certificaat_les_4_lllmbo.pdf";